import { changeLanguage } from "@i18n/i18n";
import keycloakClient from "@keycloak/keycloak";
import { LinearProgress } from "@mui/material";
import Box from "@mui/material/Box";
import { AuthClientEvent } from "@react-keycloak/core/lib/types";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { ReactNode } from "react";

// Configuración de Keycloak: siempre requerimos login para tener token válido.
// Si ya hay sesión, redirige de vuelta al UI sin pedir credenciales.
const initOptions = {
  onLoad: "login-required" as const,
  checkLoginIframe: false
};

export interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const handleKeycloakEvent = (event: AuthClientEvent) => {
    if (event === "onAuthSuccess") {
      const preferredLanguage = keycloakClient.tokenParsed?.locale || "en";
      changeLanguage(preferredLanguage);
    }
  };

  return (
    <ReactKeycloakProvider
      authClient={keycloakClient}
      initOptions={initOptions}
      onEvent={handleKeycloakEvent}
      LoadingComponent={
        <Box className="flex w-screen h-screen items-center justify-center">
          <LinearProgress color="primary" />
        </Box>
      }
    >
      {children}
    </ReactKeycloakProvider>
  );
}
